@if (isSidebarExpanded) {
  <nav class="page-sidebar" [attr.aria-label]="navigationAriaLabel">
    <ul class="page-sidebar__list">
      @for (item of menuItems; track item.label; let idx = $index) {
        <li class="page-sidebar__item">
          @if (!item.children?.length && item.visible) {
            <a
              class="menu-item"
              [routerLink]="item.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="routerLinkActiveOptions"
              [attr.data-testid]="
                'page-sidebar-link-' + linkTestIdSegment(item.label)
              "
            >
              {{ item.label }}
            </a>
          }

          @if (item.children && item.children.length > 0 && item.visible) {
            <button
              type="button"
              class="menu-item expandable"
              [id]="'sidebar-section-' + idx"
              (click)="item.expanded = !item.expanded"
              [attr.aria-expanded]="item.expanded"
              [attr.aria-controls]="'sidebar-submenu-' + idx"
              [attr.aria-label]="'Submenu of ' + item.label"
            >
              <span class="menu-item__label">{{ item.label }}</span>
              <span class="menu-item__chevron" aria-hidden="true">
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-chevron-right': !item.expanded,
                    'pi-chevron-down': item.expanded,
                  }"
                ></i>
              </span>
            </button>
            <ul
              class="page-sidebar__sublist"
              [id]="'sidebar-submenu-' + idx"
              [attr.aria-labelledby]="'sidebar-section-' + idx"
              [hidden]="!item.expanded"
            >
              @for (child of item.children; track child.route) {
                <li class="page-sidebar__subitem">
                  <a
                    class="submenu-item"
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="routerLinkActiveOptions"
                    [attr.data-testid]="
                      'page-sidebar-sublink-' + linkTestIdSegment(child.label)
                    "
                  >
                    {{ child.label }}
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </nav>
}
